import { Upload, Brain, ShieldCheck, ArrowRight } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Upload,
    title: "Load your product context",
    description:
      "Upload your ARTG data, permitted claims, and ingredient profiles for listed medicines — or your FSANZ health claim register and ingredient data for functional foods and nutraceuticals. CompliGUARD builds a product-specific compliance library that gets smarter with every review.",
  },
  {
    number: "02",
    icon: Brain,
    title: "Receive a compliance report in seconds",
    description:
      "Paste any ad, social post, web copy or campaign claim. Get an instant pass/fail assessment with flagged issues and a compliant rewrite — documented and stored automatically.",
  },
  {
    number: "03",
    icon: ShieldCheck,
    title: "Compliance review saved to Audit Vault",
    description:
      "Every review is automatically time-stamped and stored in the Audit Vault retained for the duration of the subscription — giving you a defensible compliance trail, ready for any regulatory inquiry.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 sm:py-28 bg-secondary">
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
        <p className="section-label mb-4 sm:mb-5 text-left">HOW IT WORKS</p>
        <div className="teal-rule mb-6 sm:mb-8" />
        <h2 className="text-2xl sm:text-4xl font-bold text-foreground mb-10 sm:mb-14 text-left max-w-3xl">
          From submission to compliant. In seconds.
        </h2>
        <p className="text-text-body text-base sm:text-lg leading-relaxed text-left max-w-3xl mb-10 sm:mb-14 -mt-6 sm:-mt-10">
          CompliGUARD's review engine cross-references your marketing content against the Therapeutic Goods Advertising Code 2021, the TGA Permitted Indications list, and your product's ARTG entry — returning a structured compliance report in under five minutes. Every review is specific to your product's registered indications, not general regulatory knowledge.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr_auto_1fr] gap-4 sm:gap-6 md:gap-6 items-center">
          {steps.map((step, index) => (
            <>
              <div key={step.number} className="relative p-6 sm:p-8 bg-card rounded-sm border border-border card-accent-left text-left shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover">
                <div className="text-4xl sm:text-5xl font-extrabold text-gold mb-4 sm:mb-5">
                  {step.number}
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2 sm:mb-3">
                  {step.title}
                </h3>
                <p className="text-text-body text-sm sm:text-base leading-relaxed">
                  {step.description}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div key={`arrow-${index}`} className="flex items-center justify-center">
                  <ArrowRight className="h-8 w-8 text-primary/60 hidden md:block" />
                  <div className="h-8 w-8 flex items-center justify-center md:hidden">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary/60 rotate-90">
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
